import type { TabsProps } from 'antd';

export enum Path {
  MEDIA_PLAN = '',
  TEMPLATES = '/templates'
}

export type TabItems = TabsProps['items'];

export type UseMediaPlan = () => { items: TabItems };
